import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import React, { useMemo, useEffect, useCallback } from 'react';
import ImageWrapper from "../ImageWrapper/ImageWrapper";
import DependencyManager from "../../DependencyManager";
import { Link } from 'react-router-dom';
import _fetchPopularData from "../../Store/Actions/popularData";
import { connect } from 'react-redux';
import classNames from 'classnames';
import { Button } from 'panamera-react-ui';
import { getPopularDataSelector, isFetching, isError } from "../../Store/Selectors/popularData";
var css = {
  "popularBrands": "oalp-222S8",
  "popularBrandCard": "oalp-njtvP",
  "image": "oalp-H0Elo",
  "popularText": "oalp-35nrM",
  "mobile": "oalp-1IxPS",
  "hompageFilterLight": "oalp-IxhfY",
  "cardLoader": "oalp-38cTS",
  "viewAllLink": "oalp-O4_yO",
  "loadingBtn": "oalp-CuYDk",
  "viewAllBtn": "oalp-3Teuc",
  "errContainer": "oalp-3sEpo"
};
import { POPULAR_BRANDS_ERROR_TEXT, rangeSources, MAX_WIDTH_POPULAR_BRANDS, THRESHOLD_POPULAR_BRANDS, DEFAULT_ROW_COUNT_CARDS_MOBILE, DEFAULT_ROW_COUNT_CARDS_DESKTOP } from "../../Constants/buyEngager";
import SkeletonLoader from "../SkeletonLoader/SkeletonLoader";
import TrackingInfoManager from "../../Utils/TrackingInfoManager";
import { getFilters } from "../../Utils/UrlHelpers";
import { UNKNOWN } from "../../Constants/locations";
export var PopularBrands = function PopularBrands(_ref) {
  var _ref$popularBrandsDat = _ref.popularBrandsData,
    popularBrandsData = _ref$popularBrandsDat === void 0 ? [] : _ref$popularBrandsDat,
    fetchPopularData = _ref.fetchPopularData,
    attribute = _ref.attribute,
    flow = _ref.flow,
    category = _ref.category,
    isFetching = _ref.isFetching,
    isError = _ref.isError,
    source = _ref.source,
    viewAll = _ref.viewAll,
    isDesktop = _ref.isDesktop,
    track = _ref.track,
    trackingInfo = _ref.trackingInfo,
    locationId = _ref.locationId,
    browsingMode = _ref.browsingMode,
    origin = _ref.origin,
    name = _ref.name,
    action = _ref.action,
    selectFrom = _ref.selectFrom,
    cardsCountInEachRow = _ref.cardsCountInEachRow,
    withOlxAutos = _ref.withOlxAutos,
    _ref$imageProps = _ref.imageProps,
    imageProps = _ref$imageProps === void 0 ? {} : _ref$imageProps,
    config = _ref.config;
  var DEFAULT_EACH_ROW_CARDS_COUNT = isDesktop ? DEFAULT_ROW_COUNT_CARDS_DESKTOP : DEFAULT_ROW_COUNT_CARDS_MOBILE;
  var NO_OF_LOADING_CARDS = (cardsCountInEachRow || DEFAULT_EACH_ROW_CARDS_COUNT) * 2;
  cardsCountInEachRow = cardsCountInEachRow || DEFAULT_EACH_ROW_CARDS_COUNT;
  var cardStyle = {
    flex: "0 0 ".concat(Math.floor(MAX_WIDTH_POPULAR_BRANDS / cardsCountInEachRow) - THRESHOLD_POPULAR_BRANDS, "%")
  };
  var isOlxMobbi = config === null || config === void 0 ? void 0 : config.get('isOlxMobbi');
  useEffect(function () {
    var reqProps = {
      category: category,
      flow: flow,
      attribute: attribute
    };
    fetchPopularData(reqProps);
  }, [attribute, category, fetchPopularData, flow]);
  var dependencyFunction = DependencyManager.getDependency('functions');
  var parsedPopularBrandsData = useMemo(function () {
    return popularBrandsData.map(function (_ref2) {
      var value = _ref2.value,
        imageUri = _ref2.imageUri,
        name = _ref2.name,
        range = _ref2.range;
      return {
        value: value,
        name: name,
        range: range,
        image: Object.assign(Object.assign({}, imageProps), {
          url: imageUri
        })
      };
    });
  }, [popularBrandsData]);
  var cardClickHandler = useCallback(function (textVal) {
    return function () {
      if (track && trackingInfo && trackingInfo.clickEvent && trackingInfo.clickEvent.name) {
        var trackingEventName = trackingInfo.clickEvent.name;
        var calculatedTrackingInfo = TrackingInfoManager.getTrackingInfo({
          variants_shown: name,
          browsing_location_id: locationId || UNKNOWN,
          browsing_mode: browsingMode,
          origin: origin,
          chosen_option: textVal,
          select_from: name
        });
        track === null || track === void 0 ? void 0 : track(trackingEventName, calculatedTrackingInfo);
      }
    };
  }, [browsingMode, locationId, name, origin, track, trackingInfo]);
  var LoadingCards = _toConsumableArray(new Array(NO_OF_LOADING_CARDS)).map(function () {
    return /*#__PURE__*/React.createElement("div", {
      className: classNames(css.popularBrandCard, css.cardLoader),
      style: cardStyle
    }, /*#__PURE__*/React.createElement(SkeletonLoader, null));
  });
  if (isFetching && LoadingCards) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: css.popularBrands
    }, LoadingCards), viewAll && /*#__PURE__*/React.createElement("div", {
      className: css.viewAllLink
    }, /*#__PURE__*/React.createElement(Button, {
      type: "secondaryBtn",
      className: css.loadingBtn,
      fixed: true
    }, /*#__PURE__*/React.createElement(SkeletonLoader, null)), " "));
  } else if (!isFetching && !isError && parsedPopularBrandsData.length) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: css.popularBrands,
      "data-aut-id": "popularBrands"
    }, parsedPopularBrandsData.map(function (_ref3, index) {
      var _classNames;
      var value = _ref3.value,
        image = _ref3.image,
        name = _ref3.name,
        range = _ref3.range;
      var linkTo = dependencyFunction.buildURL({
        category: {
          id: category
        },
        params: {
          filter: Object.assign({}, getFilters(action, value, range, withOlxAutos))
        }
      }, {}, !!isOlxMobbi);
      var linkToProp = {
        pathname: linkTo === null || linkTo === void 0 ? void 0 : linkTo.slice(0, linkTo.indexOf('?')),
        search: linkTo === null || linkTo === void 0 ? void 0 : linkTo.slice(linkTo.indexOf('?')),
        state: {
          select_from: selectFrom
        }
      };
      return /*#__PURE__*/React.createElement(Link, {
        to: linkToProp,
        className: classNames(css.popularBrandCard, (_classNames = {}, _defineProperty(_classNames, css.hompageFilterLight, rangeSources.includes(source)), _defineProperty(_classNames, css.mobile, !isDesktop), _classNames)),
        key: index,
        id: value,
        onClick: cardClickHandler(name),
        style: cardStyle
      }, name && range && /*#__PURE__*/React.createElement("p", {
        className: css.popularText
      }, name), image.url && /*#__PURE__*/React.createElement(ImageWrapper, {
        image: image,
        className: css.image
      }));
    })), viewAll && /*#__PURE__*/React.createElement(Link, {
      to: "".concat(isOlxMobbi ? "/olxmobbi".concat(viewAll.url) : viewAll.url),
      className: css.viewAllLink
    }, /*#__PURE__*/React.createElement(Button, {
      type: "secondaryBtn",
      fixed: true,
      className: css.viewAllBtn,
      onClick: cardClickHandler(viewAll.text)
    }, viewAll.text), " "));
  }
  return isDesktop ? null : /*#__PURE__*/React.createElement("div", {
    className: css.errContainer
  }, isError && /*#__PURE__*/React.createElement("span", null, POPULAR_BRANDS_ERROR_TEXT));
};
export var mapStateToProps = function mapStateToProps(state, ownProps) {
  var attribute = ownProps.attribute,
    flow = ownProps.flow,
    category = ownProps.category;
  var selectorProps = {
    attribute: attribute,
    flow: flow,
    category: category
  };
  return {
    popularBrandsData: getPopularDataSelector(state, selectorProps),
    isError: isError(state, selectorProps),
    isFetching: isFetching(state, selectorProps)
  };
};
export var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    fetchPopularData: function fetchPopularData(reqProps) {
      return dispatch(_fetchPopularData(reqProps));
    }
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(PopularBrands);